import $ from 'jquery';
import ColorCurve from '@/assets/js/ColorCurve';

export default class Blocks {
	addFixed(blockOptions) {
		let genericBlockObject = this.createBlockObject();
		let blockObject = { ...genericBlockObject, ...blockOptions, type: "fixed" };
		lutify.blocks.push(blockObject);
	}

	add(blockOptions) {
		let genericBlockObject = this.createBlockObject();
		genericBlockObject.active = 0;
		let blockObject = { ...genericBlockObject, ...blockOptions, type: "dynamic" };
		lutify.blocks.splice(this.getDynamicEndIndex(), 0, blockObject);
	}

	createBlockObject() {
		return {
			active: 1,
			expanded: true,
			opacity: 100,
		};
	}

	getDynamicEndIndex() {
		return lutify.blocks.length - config.endFixedPasses;
	}

	primaryBlockHandler($block) {
		$block = $block.closest(".adjustment-block");
		if ($block.attr("class").indexOf("disabled_block") > -1) return;

		if (!$block.hasClass("preview-based") && !lutify.activeBefore) UI.hideLUTtemplates();
		if (!$block.hasClass("magic-mode-block") && !lutify.activeBefore) UI.hideMagicModeNav();

		if ($block.attr("class").indexOf("selected_block") == -1 && $block.attr("class").indexOf("disabled_block") == -1) {
			$(".selected_block")
				.find('input[type="range"]')
				.blur(); // remove focus from previous block's slider
			$(".selected_block")
				.find(".ui-state-active, .ui-state-focus")
				.blur(); // remove focus from vertical bars (primaries/log primaries)
			$(".selected_block").removeClass("selected_block");
			$block.addClass("selected_block");
			var block = $block.attr("rel").split("block_");
			var blockNum = block[1];
			lutify.activeBlock = parseInt(blockNum);
		}
	}

	// Switch handler for turning block on/off
	switchHandler($switch) {
		let rootElement = $switch.closest(".adjustment-block");

		if ($switch.is(":checked")) {
			lutify.getActiveBlock().active = 1;
			blocks.enablePasses();

			$(rootElement).removeClass("--off");
		} else {
			lutify.getActiveBlock().active = 0;
			blocks.storePassesEnabledStatus();
			blocks.disablePasses();

			$(rootElement).addClass("--off");
			$switch.prop("checked", false);
		}

		gpu.render();
		lutPreviewer.render();
	}

	storePassesEnabledStatus(block = lutify.getActiveBlock()) {
		let passesEnabledStatus = [];
		block.passes.forEach(pass => {
			passesEnabledStatus.push(pass.enabled);
		});

		block.lastPassesEnabledStatus = passesEnabledStatus;
	}

	disablePasses(block = lutify.getActiveBlock()) {
		block.passes.forEach(pass => (pass.enabled = false));
	}

	enablePasses(block = lutify.getActiveBlock()) {
		if (block.lastPassesEnabledStatus) {
			block.passes.forEach((pass, index) => {
				pass.enabled = block.lastPassesEnabledStatus[index];
			});
		}
	}

	checkSwitchHandler($el, triggerEvent = true) {
		if (!$el.find(".controls-wrapper .switch input").is(":checked")) {
			if (triggerEvent) $el.find(".controls-wrapper .switch input").trigger("click");
			else $el.find(".controls-wrapper .switch input").prop("checked", true);
		}
	}

	getDynamicBlocks() {
		return lutify.blocks.filter(block => block.type == "dynamic");
	}

	getAllPassesToBlock(num) {
		let passes = [];
		for (let i = 0; i <= num - 1; i++) {
			passes.push(...lutify.blocks[i].passes.map(pass => pass))
		}

		return passes;
	}

	getAllPassesToPass(pass_id) {
		let passes = [];
		let passIndex = gpu.getPassIndexById(pass_id);
		// let clonedPasses = [...gpu.composer.passes];
		for (let i = 0; i <= passIndex - 1; i++) {
			passes.push(gpu.composer.passes[i])
		}

		return passes;
	}

	getBlockIndex_byBlockNum(blockNum) {
		let index;
		lutify.blocks.forEach((block, i) => {
			if (block.blockNum !== undefined && block.blockNum == blockNum) index = i;
		});
		return index ? index : null;
	}

	createCurves(curveNames, blockNum, createUICanvas = true, testCurves = false) {
		curveNames.forEach(curveName => {
			let blockCanvasName;
			if (createUICanvas) blockCanvasName = UI.createBlockCanvas(curveName, blockNum);
			else blockCanvasName = `${curveName}-${blockNum - config.endFixedPasses}`;

			if (!testCurves) {
				lutify.getActiveBlock().curves.push({
					name: blockCanvasName,
					colorCurve: new ColorCurve(blockCanvasName),
				});
			} else {
				lutify.getActiveBlock().testCurves.push({
					name: blockCanvasName,
					colorCurve: new ColorCurve(blockCanvasName),
				});
			}
		});
	}

	removeAllDynamic() {
		$("#blocks-container .block").each((i, block) => {
			if (block.classList.contains('raw-development-block')) return;
			blocks.removeBlock($(block));
		});
	}

	removeBlock($block) {
		let blockIndex = this.getBlockIndex_byBlockNum($block.attr("orignum"));
		let blockCurves = lutify.blocks[blockIndex].curves;

		// First removing the gpu pass
		lutify.blocks[blockIndex].passes.forEach(pass => {
			gpu.removePass(pass.uid);
		});

		// Second we remove the block from blocks object
		lutify.blocks.splice(blockIndex, 1);

		// Third we remove the block from UI
		UI.removeBlock($block);
		if ($block.hasClass("preview-based")) UI.hideLUTtemplates();

		// Only for blocks which generate curve canvases
		if (blockCurves) {
			blockCurves.forEach(blockCurve => {
				UI.removeBlockCanvas(blockCurve.name);
			});
		}

		// Only when no user selected blocks, re-enable fixed identity pass (see config object)
		// if (lutify.blocks.length == config.totalFixedPasses) gpu.composer.passes[config.identityIndex].enabled = true;

		lutify.activeBlock = null;
		gpu.render();
	}

	getNewBlockNumber() {
		// We have 3 initial passes (render, IDT, ODT)
		// So position 3 is the first position for an adjustment block
		let blockNum = 1;
		lutify.blocks.forEach(block => {
			if (block.blockNum) {
				if (block.blockNum > blockNum) blockNum = block.blockNum;
			}
		});

		if (lutify.blocks.length - 2 == 0) return blockNum;
		else return blockNum + 1;
	}

	moveBlock(blockNum, newBlockIndex) {
		let oldBlockIndex = this.getBlockIndex_byBlockNum(blockNum);
		lutify.blocks.splice(2 + newBlockIndex, 0, lutify.blocks.splice(oldBlockIndex, 1)[0]);
	}

	getFirstPassUid(blockNum) {
		let blockIndex = this.getBlockIndex_byBlockNum(blockNum);
		let block = lutify.blocks[blockIndex];

		if (block.pass) return block.pass.uid;
		else return block.pass[0];
	}

	getPassesNumber(blockNum) {
		let blockIndex = this.getBlockIndex_byBlockNum(blockNum);
		let block = lutify.blocks[blockIndex];

		if (block.pass) return 1;
		else return block.passes.length;
	}

	getPasses_fromAllBlocks() {
		let passesList = [];
		lutify.blocks.forEach(block => {
			if (block.pass) passesList.push(block.pass);
			else {
				block.passes.forEach(pass => {
					passesList.push(pass);
				});
			}
		});
		return passesList;
	}

	resetBlock($block, $specificSlider = null, omitPassIndex = null) {
		// When slider is double clicked
		if ($specificSlider) {
			if ($specificSlider.data("default-value")) $specificSlider.val($specificSlider.data("default-value"));
			else $specificSlider.val(0);
			$specificSlider.trigger("input");

			let disablePass = true;
			let targetPassIndex = $specificSlider.data("pass-index") || 0;
			if (lutify.getActiveBlock().name == "magicMode") targetPassIndex = lutify.magicMode.activeStep;

			// Checking if we have more slider working with same pass, checking their values.
			// If only one pass present, the pass will be disabled.
			lutify.getActiveBlock().passes.forEach((pass, i) => {
				if (targetPassIndex == i) {
					$block.find(`.range_slider[data-pass-index="${targetPassIndex}"]`).each(function(i, rangeSlider) {
						let defaultValue = 0;
						if ($(rangeSlider).data("default-value")) defaultValue = $(rangeSlider).data("default-value");
						if (rangeSlider.value !== defaultValue.toString()) disablePass = false;
					});
				}
			});

			if (disablePass && lutify.getActiveBlock().blendingModeName == "Normal") {
				lutify.getActiveBlock().passes[targetPassIndex].enabled = false;
			}
		}

		// When reset button is clicked
		else {
			$block.find(".range_value").each(function() {
				if ($(this).data("default-value")) $(this).val($(this).data("default-value"));
				else $(this).val(0);
				$(this).trigger("change");
			});

			if (lutify.getActiveBlock().name == "colourMatch") {
				$block.find(".block-control-checkbox").each(function() {
					if ($(this).data("default-value")) $(this).prop('checked', true)
					else $(this).prop('checked', false)
				});
			}

			lutify.getActiveBlock().passes.forEach((pass, index) => {
				if (index !== omitPassIndex) pass.enabled = false;
			});

			$block.find('.blending-mode__items-container > span[data-id="0"]').trigger("click");
		}
	}

	spliceToInitial() {
		let ODTblock = lutify.blocks[lutify.blocks.length - 1];
		lutify.blocks.splice(2);
		lutify.blocks.push(ODTblock);
	}

	updateBlendingMode(id) {
		let changeAllPasses = [10, 21, 22, 35, 50, 51, 52, 53];
		if (changeAllPasses.includes(parseInt(id))) {
			lutify.getActiveBlock().passes.forEach(pass => (pass.uniforms.blendID.value = parseInt(id)));
		} else {
			lutify.getActiveBlock().passes.forEach(pass => {
				if (pass.uniforms.blendID) pass.uniforms.blendID.value = 0
			});

			if (lutify.getActiveBlock().passes[lutify.getActiveBlock().passes.length - 1].uniforms.blendID) {
				lutify.getActiveBlock().passes[lutify.getActiveBlock().passes.length - 1].uniforms.blendID.value = parseInt(id);
			}
		}

		gpu.render();
	}
}
